import React from "react";
import classNames from "classnames";

const Index = ({ children, isActive, keyColor, ...rest }) => {
  const classes = classNames({
    "tab-button": true,
    "is-active": isActive
  });

  const style = {};
  if (isActive) {
    style.borderBottomColor = keyColor;
  }

  return (
    <button className={classes} style={style} type="button" {...rest}>
      {children}
    </button>
  );
};

export default Index;
